export default "__VITE_ASSET__7FS3XLyN__"